import { render, staticRenderFns } from "./VCardActivity.vue?vue&type=template&id=2105d55d&scoped=true"
import script from "./VCardActivity.vue?vue&type=script&lang=js"
export * from "./VCardActivity.vue?vue&type=script&lang=js"
import style0 from "./VCardActivity.vue?vue&type=style&index=0&id=2105d55d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2105d55d",
  null
  
)

export default component.exports